export const UserFooterIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="30"
    viewBox="0 0 21 21"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5009 0C7.48802 0 5.04609 2.45244 5.04609 5.47826V6.3913C5.04609 9.41713 7.48802 11.8696 10.5009 11.8696C13.5138 11.8696 15.9557 9.41713 15.9557 6.3913V5.47826C15.9557 2.45244 13.5138 0 10.5009 0ZM10.4991 14.6087C6.85713 14.6087 2.18418 16.5871 0.839578 18.3429C0.00863039 19.4285 0.799647 21 2.16244 21H18.8376C20.2004 21 20.9914 19.4285 20.1604 18.3429C18.8158 16.588 14.1411 14.6087 10.4991 14.6087Z"
      fill="currentColor"
    />
  </svg>
);
